import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { ClipLoader } from "react-spinners";
import styles from "./styles.module.css";
import Logo from "../../assets/logo.png";
import LoginImage from "../../assets/bg-login.png";
import MensagemErroForm from "../../components/mensagem-erro-form";
import {
  FaEnvelope,
  FaQuestionCircle,
  FaWhatsapp
} from "react-icons/fa";

function LoginPage() {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const { login } = useAuth();
  const [erro, setErro] = useState(null);
  const [loadingBotao, setLoadingBotao] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro(null);
    setLoadingBotao(true);

    try {
      await login(formData.email, formData.password);
      navigate("/");
    } catch (erro) {
      setErro(erro.message);
    } finally {
      setLoadingBotao(false);
    }
  };

  return (
    <>
      <div className={styles.loginPage}>
        <div className={styles.loginImageContainer}>
          <img src={LoginImage} alt="Estatísticas eleitorais" className={styles.loginImage} />
        </div>
        <div className={styles.loginContainer}>
          <div className={styles.loginHeader}>
            <img src={Logo} alt="Logo" className={styles.logo} />
            <h2>Acesse sua conta</h2>
          </div>
          <form className={styles.loginForm} onSubmit={handleSubmit}>
            <div className={styles.formGroup}>
              <label htmlFor="email">E-mail</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Digite seu e-mail"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="password">Senha</label>
              <input
                type="password"
                id="password"
                name="password"
                placeholder="Digite sua senha"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>
            {erro && <MensagemErroForm className={styles.mensagemErro} erro={erro} />}
            <button
              type="submit"
              disabled={loadingBotao}
            >
              {loadingBotao ? (
                <ClipLoader size={15} color="#FFFFFF" />
              ) : (
                "Entrar"
              )}
            </button>
          </form>
          <div className={styles.loginFooter}>
            <h5>Contato e Suporte</h5>

            <span>
              <FaEnvelope className={styles.icon} /> Email:{" "}
              <a href="mailto:contato-votovisao@gmail.com">
                contato-votovisao@gmail.com
              </a>
            </span>
            <span>
              <FaQuestionCircle className={styles.icon} /> Suporte técnico/vendas:
            </span>
            <span>
              <FaWhatsapp className={styles.icon} />{" "}
              São Paulo:{" "}
              <a
                href="https://wa.me/5511981419381"
                target="_blank"
                rel="noopener noreferrer"
              >
                (11) 98141-9381
              </a>
            </span>
            <span>
              <FaWhatsapp className={styles.icon} />{" "}
              Pernambuco e demais regiões:{" "}
              <a
                href="https://wa.me/5581993122709"
                target="_blank"
                rel="noopener noreferrer"
              >
                (81) 99312-2709
              </a>
            </span>
            <span>
              <a
                href="/analises-votacao-bolsonaro-2018-2022.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                Clique aqui e acesse análises reais
              </a>
            </span>
          </div>
        </div>
      </div>
    </>
  );
}

export default LoginPage;